import { on } from '@ember/modifier';
import type Owner from '@ember/owner';
import Component from '@glimmer/component';
import t from 'ember-intl/helpers/t';
import ComputerNetworkSettings from 'parog-web/components/cnam-services-access-form/authentication/set-pin-code-and-computer-settings/computer-network-settings';
import type DmpConnectJSAuthenticationContextAdapter from 'parog-web/contexts/dmpconnect-js/authentication-context-adapter';
import Button from 'ui-kit/components/button';
import fuiPopup from 'wise-fui-modules/modifiers/fui-popup';

interface Args {
  context: DmpConnectJSAuthenticationContextAdapter;
  onDismiss: () => void;
}
export default class CnamServicesAccessFormAuthenticationSetPinCodeAndComputerSettingsComponent extends Component<Args> {
  get canSubmit(): boolean {
    return (
      this.args.context.pinCodeManager.isTypedPinCodeValid &&
      Boolean(this.args.context.computerLocation)
    );
  }

  constructor(owner: Owner, args: Args) {
    super(owner, args);

    this.args.context.computerLocation =
      this.args.context.dmpConnect.selectedHealthCentreForMedic(
        this.args.context.medic
      ) || undefined;
  }

  onPinCodeChanged = e => {
    this.args.context.pinCodeManager.typedPinCode = e.target.value;
  };

  onSubmit = async (event: Event): Promise<void> => {
    event.preventDefault();
    await this.args.context.transitionTo();
  };

  setSelectedHealthCentre = (value: string): void => {
    this.args.context.computerLocation = value;
  };

  <template>
    <div data-test-authentication-step>
      <form
        class='ui form'
        id='dmp-access-form-authentication-state-form'
        {{on 'submit' this.onSubmit}}
      >

        <div class='field'>
          <p>Insérez votre carte CPS, puis saisissez votre code d'accès (code
            PIN).</p>

          <label class='ui header' for='pinCode'>Code d'accès (à 4 chiffres)
            <span class='ml8'>
              <i
                class='circle help icon'
                {{fuiPopup inline=true position='right center'}}
              ></i>
              <div class='ui very wide popup' data-test-popup>
                <p>{{! eslint-disable ember/template-no-triple-curlies }}
                  {{{t
                    'reimbursements.retrieving-modal-messages.pin-code-tooltip'
                  }}}</p>
              </div>
            </span>
          </label>

          <input
            id='pinCode'
            type='password'
            pattern='[0-9]*'
            value={{@context.pinCodeManager.typedPinCode}}
            placeholder='Ex. : 1234'
            min='0'
            max='9999'
            data-test-input='pinCode'
            {{on 'input' this.onPinCodeChanged}}
          />
        </div>

        <ComputerNetworkSettings
          @context={{@context}}
          @onChange={{this.setSelectedHealthCentre}}
        />

        <div class='form-buttons'>
          <Button
            type='button'
            class='ui fluid form-button'
            {{on 'click' @onDismiss}}
          >
            Annuler
          </Button>
          <Button
            type='submit'
            data-test-button='submit-dmp-access-form'
            class='ui fluid primary form-button
              {{unless this.canSubmit "disabled"}}'
          >
            Continuer
          </Button>
        </div>
      </form>
    </div>
  </template>
}
